// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__M26P3","wrapper":"Footer_wrapper__nGTB0","paragraph":"Footer_paragraph__0r47m","link":"Footer_link__QahP1"};